import { defineComponent as _defineComponent } from 'vue'
import { useFloorsStore, useLocationsStore } from '@/stores'
import { computed } from 'vue'
import { t } from '@/plugins/i18n';
import TooltippedText from "@eencloud/eewc-components/src/components/tooltip/TooltippedText/TooltippedText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectWrappers',
  setup(__props) {

const floors = useFloorsStore()
const locations = useLocationsStore()

// Select buttons
const currentLocation = computed(() => {
  return {
    text: locations?.currentLocation?.name,
    value: locations?.currentLocation?.id,
    ...locations?.currentLocation
  }
})

const currentFloor = computed(() => {
  return {
    text: floors?.currentFloor?.name,
    value: floors?.currentFloor?.id,
    ...floors?.currentFloor
  }
})

return { __sfc: true,floors, locations, currentLocation, currentFloor, t, TooltippedText }
}

})